export default () => ({
    calculating: false,
    calculateTimeout: null,

    calculateTax() {
        this.calculating = true;
        clearTimeout(this.calculateTimeout);

        this.calculateTimeout = setTimeout(
            () => this.$wire.calculateTax().then(() => this.calculating = false)
        , 300);
    }
});
